import { CopilotChannelContext } from 'copilot-toolkit/channel/CopilotChannelContext';
import { useSubscribeToCopilotChannel } from 'copilot-toolkit/channel/hooks/useSubscribeToCopilotChannel';
import emptyFunction from 'react-utils/emptyFunction';
import { useCallback, useContext, useRef, useState } from 'react';
import { MSG_TYPE_MODAL_DIALOG_CLOSE } from 'ui-addon-iframeable/messaging/IFrameMessageTypes';
import { useHostAppName } from './hooks/useHostAppName';
import { buildModalUrl } from './utils/buildModalUrl';

// @ts-expect-error Not Typed
import { IFrame } from 'ui-addon-iframeable/host/IFrame';
import { jsx as _jsx } from "react/jsx-runtime";
const BreezeImageLightboxModalHost = () => {
  const [isVisible, setIsVisible] = useState(false);
  const hostAppName = useHostAppName();
  const contextValue = useContext(CopilotChannelContext);
  const instanceId = contextValue === null || contextValue === void 0 ? void 0 : contextValue.instanceId;
  const iframeSrcRef = useRef(undefined);
  if (!iframeSrcRef.current) {
    iframeSrcRef.current = buildModalUrl('/breeze-modal', hostAppName, instanceId);
  }
  const handleMessage = useCallback(message => {
    var _message$payload;
    if (((_message$payload = message.payload) === null || _message$payload === void 0 ? void 0 : _message$payload.type) === MSG_TYPE_MODAL_DIALOG_CLOSE) {
      setIsVisible(false);
    }
  }, []);
  const handleOpen = useCallback(() => setIsVisible(true), []);
  useSubscribeToCopilotChannel('OPEN_BREEZE_IMAGE_LIGHTBOX_MODAL', handleOpen);
  const containerStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 1112,
    display: isVisible ? 'block' : 'none',
    pointerEvents: 'auto'
  };
  return /*#__PURE__*/_jsx("div", {
    style: containerStyle,
    children: /*#__PURE__*/_jsx(IFrame, {
      appName: "breeze-modal-ui",
      height: isVisible ? '100%' : 0,
      initTimeout: 20000,
      name: "breeze-image-lightbox-modal",
      onMessage: handleMessage,
      onReady: emptyFunction,
      scrolling: false,
      src: iframeSrcRef.current,
      width: isVisible ? '100%' : 0
    })
  });
};
export default BreezeImageLightboxModalHost;